import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute, GuestOnlyRoute } from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Onboarding from "@/pages/Onboarding";
import PlacementTest from "@/pages/PlacementTest";
import AppShell from "@/pages/AppShell";
import Dashboard from "@/pages/Dashboard";
import ComingSoon from "@/pages/ComingSoon";
import Lesson from "@/pages/Lesson";
import Intensive from "@/pages/Intensive";
import Reviews from "@/pages/Reviews";
import Conversation from "@/pages/Conversation";
import Translate from "@/pages/Translate";
import Pronunciation from "@/pages/Pronunciation";
import Podcasts from "@/pages/Podcasts";
import Parcours from "@/pages/Parcours";
import ProgressPage from "@/pages/ProgressPage";
import ProfileSettings from "@/pages/ProfileSettings";
import POC from "@/pages/POC";
import PublicShare from "@/pages/PublicShare";
import PublicCertificate from "@/pages/PublicCertificate";
import Certificate from "@/pages/Certificate";
import Subscription from "@/pages/Subscription";
import SubscriptionReturn from "@/pages/SubscriptionReturn";
import Guide from "@/pages/Guide";
import CGU from "@/pages/CGU";
import Privacy from "@/pages/Privacy";
import Contact from "@/pages/Contact";

export default function App() {
    return (
        <div className="App min-h-screen bg-paper text-ink">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/poc" element={<POC />} />
                        <Route path="/partage/:id" element={<PublicShare />} />
                        <Route path="/certificat/:certId" element={<PublicCertificate />} />
                        <Route path="/guide" element={<Guide />} />
                        <Route path="/cgu" element={<CGU />} />
                        <Route path="/confidentialite" element={<Privacy />} />
                        <Route path="/contact" element={<Contact />} />

                        <Route
                            path="/login"
                            element={
                                <GuestOnlyRoute>
                                    <Login />
                                </GuestOnlyRoute>
                            }
                        />
                        <Route
                            path="/register"
                            element={
                                <GuestOnlyRoute>
                                    <Register />
                                </GuestOnlyRoute>
                            }
                        />

                        <Route
                            path="/onboarding"
                            element={
                                <ProtectedRoute>
                                    <Onboarding />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/placement/:testId"
                            element={
                                <ProtectedRoute>
                                    <PlacementTest />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            element={
                                <ProtectedRoute>
                                    <AppShell />
                                </ProtectedRoute>
                            }
                        >
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/lesson" element={<Lesson />} />
                            <Route path="/intensive" element={<Intensive />} />
                            <Route
                                path="/reviews"
                                element={<Reviews />}
                            />
                            <Route path="/conversation" element={<Conversation />} />
                            <Route path="/translate" element={<Translate />} />
                            <Route path="/pronunciation" element={<Pronunciation />} />
                            <Route path="/podcasts" element={<Podcasts />} />
                            <Route path="/parcours" element={<Parcours />} />
                            <Route path="/parcours/:trackId" element={<Parcours />} />
                            <Route path="/settings/profile" element={<ProfileSettings />} />
                            <Route path="/abonnement" element={<Subscription />} />
                            <Route path="/abonnement/retour" element={<SubscriptionReturn />} />
                            <Route path="/certificats/:certId" element={<Certificate />} />
                            <Route
                                path="/program"
                                element={
                                    <ComingSoon
                                        title="Parcours"
                                        blurb="Vue détaillée de votre programme jour par jour — phase 3."
                                    />
                                }
                            />
                            <Route path="/progress" element={<ProgressPage />} />
                        </Route>

                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
            <Toaster position="top-right" richColors closeButton />
        </div>
    );
}
